import Service from "./abstract/Service";

export default class AppService extends Service {

  findReleaseNumber() {
    return this.get(env.API_URL + `/info/release`);
  }
}
